import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
}
export function SectionTag({
  children
}: SectionTagProps) {
  return <span className="inline-block rounded-md bg-flame px-3 py-1 text-xs font-bold uppercase tracking-[0.1em] text-ink" data-id="element-264" data-mp="fyunl6k57s3m">
      {children}
    </span>;
}